export const EmailIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1629_8791)">
        <path
          d="M19.2536 5.55534C19.2536 4.63867 18.5036 3.88867 17.5869 3.88867H4.25358C3.33691 3.88867 2.58691 4.63867 2.58691 5.55534M19.2536 5.55534V15.5553C19.2536 16.472 18.5036 17.222 17.5869 17.222H4.25358C3.33691 17.222 2.58691 16.472 2.58691 15.5553V5.55534M19.2536 5.55534L10.9202 11.3887L2.58691 5.55534"
          stroke="#475569"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1629_8791">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.920166 0.554688)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
